import React from "react";
import "./Navbar.css";
import { MenuItems } from "../MenuItems/MenuItems";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { useState } from "react";
import { Link } from "react-router-dom";

export default function Navbar() {
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(!open);
  };

  return (
    <nav className="navbarItems">
      <h1 className="navbar-logo">NK Travel</h1>
      <div className="menu-icons">
        <i onClick={handleClick}>{open ? <CloseIcon /> : <MenuIcon />}</i>
      </div>

      <ul className={open ? "nav-menu active" : "nav-menu"}>
        {MenuItems.map((item, index) => {
          return (
            <li key={index}>
              <Link onClick={handleClick} to={item.url} className={item.cName}>
                <i> {item.icon}</i>

                {item.title}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
